import {
  CommandBar,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  IColumn,
  ICommandBarItemProps,
  IDetailsListStyleProps,
  IDetailsListStyles,
  IStyleFunctionOrObject,
  ShimmeredDetailsList,
} from "@fluentui/react";
import React from "react";
import themeBase from "../../utils/theme/themeBase";

interface ITableSelectRow {
  loading : boolean;
  leftBar: ICommandBarItemProps[];
  rigthBar?: ICommandBarItemProps[];
  columns: IColumn[];
  items: any[];
  styles?: IStyleFunctionOrObject<IDetailsListStyleProps, IDetailsListStyles>;
}

export const TableSelectRow = (props: ITableSelectRow) => {
  return (
    <>
      <CommandBar
        items={props.leftBar.length === 0 ? [] : props.leftBar}
        farItems={props?.rigthBar}
        styles={themeBase.commadStyles}
      />
 
        <ShimmeredDetailsList
          styles={props.styles}
          compact={true}
          layoutMode={DetailsListLayoutMode.justified}
          columns={props.columns}
          items={props.items}
          isHeaderVisible={true}
          selectionPreservedOnEmptyClick={true}
          enableShimmer={props.loading }
        />
     
    </>
  );
};
